(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .factory('wagerReportHub', wagerReportHub);

    wagerReportHub.$inject = ['hub', app.modules.common.constants.appsettings];
    function wagerReportHub(hub, ggSettings) {
        // Unfortunately, we must return a function.  This is a service that needs to be transient.
        return function () {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.signalR;
            var result = hub(apipath, 'wagerReportHub');
            result.getWagerReport = getWagerReport;
            return result;

            function getWagerReport(roundId) {
                return this.invoke('getWagerReport', roundId);
            }
        }
    }
})();